import { SettingsQuery } from '@1bill-app/services/settings/settings.query';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-popover-better-deal-product-consent',
  templateUrl: './popover-better-deal-product-consent.component.html',
  styleUrls: ['./popover-better-deal-product-consent.component.scss'],
})
export class PopoverBetterDealProductConsentComponent implements OnInit {
  @Input() productId: number;
  @Input() planName:string;
  @Input() retailerName: string;

  hasConsent:boolean = false;
  consentForm: FormGroup;
  oneBillMail: string;
  constructor(private popoverController:PopoverController, private settingsQuery: SettingsQuery) { }

  ngOnInit() {
    let firstName = this.settingsQuery.getValue().firstName;
    let email = this.settingsQuery.getValue().billEmail;

    this.consentForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),        
      email: new FormControl('', [
        Validators.email,
        Validators.required,
        // Validators.pattern('[a-zA-Z0-9._-]{2,}@[a-zA-Z]{2,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})'),
      ]),      
    });

    this.consentForm.setValue({firstName,email});
    this.oneBillMail = email;
  }

  dismiss(confirmed: boolean) {

    if(!confirmed)
      this.popoverController.dismiss(null);

    //Check user is using 1bill mail and aggree condition
    if(!this.hasConsent && this.consentForm.get('email').value == this.settingsQuery.getValue().billEmail)
      return;

    if(confirmed){
      this.popoverController.dismiss({
        firstName:this.consentForm.get('firstName').value,
        email: this.consentForm.get('email').value,
        productId: this.productId,
      });
    }
    
  }

}
